import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { CONTACT } from "@/config/contact";
import { useI18n } from "@/i18n/i18n";

export default function WhatsAppFab() {
  const { pathname } = useLocation();
  const { tr } = useI18n();
  if (pathname.startsWith("/admin")) return null;
  const href = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(tr.whatsapp.message)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.6, type: "spring", stiffness: 220, damping: 16 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="wa-fab fixed bottom-24 right-6 z-[60] h-14 w-14 sm:h-16 sm:w-16 rounded-full flex items-center justify-center text-white shadow-2xl"
      style={{
        background: "linear-gradient(180deg, #25D366 0%, #1FB257 100%)",
        boxShadow: "0 18px 40px -10px rgba(37,211,102,0.55)",
      }}
      aria-label={tr.whatsapp.label}
      data-testid="whatsapp-fab"
    >
      <svg viewBox="0 0 24 24" className="h-7 w-7 sm:h-8 sm:w-8" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.78 11.78 0 0 0 12.06 0C5.5 0 .15 5.34.15 11.91a11.83 11.83 0 0 0 1.65 6.04L0 24l6.22-1.63a11.9 11.9 0 0 0 5.84 1.49h.01c6.56 0 11.91-5.34 11.91-11.91a11.83 11.83 0 0 0-3.46-8.47ZM12.06 21.8h-.01a9.86 9.86 0 0 1-5.02-1.37l-.36-.21-3.69.97.99-3.6-.24-.37a9.85 9.85 0 0 1-1.51-5.31c0-5.46 4.45-9.9 9.92-9.9a9.86 9.86 0 0 1 7 2.9 9.83 9.83 0 0 1 2.9 7c0 5.46-4.45 9.89-9.98 9.89Zm5.43-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35Z" />
      </svg>
    </motion.a>
  );
}
